import { render } from "./TimelineConsentCard.vue?vue&type=template&id=4a879752&scoped=true"
import script from "./TimelineConsentCard.vue?vue&type=script&lang=js"
export * from "./TimelineConsentCard.vue?vue&type=script&lang=js"

import "./TimelineConsentCard.vue?vue&type=style&index=0&id=4a879752&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a879752"]])

export default __exports__